var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrendDown = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.3599 3.375C14.3029 3.37531 14.827 4.46662 14.2378 5.20312L8.68309 12.1465C8.33284 12.5841 7.66718 12.5841 7.31688 12.1465L1.76122 5.20312C1.17213 4.46658 1.697 3.37518 2.64012 3.375H13.3599Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrendDown);
export default ForwardRef;